import React from 'react';
import styles from './UserGuide.module.css'
import ChevronIcon from "../General/icons/chevronIcon";
import PDFModal from "./modals/PDFModal";
import {useSelector} from "react-redux";
import {getUserGuideEntriesAPI} from "../../api/userGuideAPI";
import Loading from "../General/loading/loading";

const UserGuide = () => {

    const docket = useSelector((state) => state.navigation.currentDocket);
    const jwt = useSelector((state) => state.user.jwt);

    const [selectedHelpArticle, setSelectedHelpArticle] = React.useState([-1, '']);
    const [guideData, setGuideData] = React.useState({})
    const [loading, setLoading] = React.useState(true)

    const resetModal = () => {
        setSelectedHelpArticle([-1, ''])
    }

    React.useEffect(() => {
        setLoading(true)
        getUserGuideEntriesAPI(jwt, docket).then(r => {
            setGuideData(r)
            setLoading(false)
        }).catch(e => {
            setGuideData({})
            setLoading(false)
        })
    }, [jwt, docket])

    return (
        <div className={styles.userGuide}>
            <h3 className={styles.heading}>How can we help you?</h3>
            <div className={styles.content}>
                {
                    loading && <Loading />
                }
                {
                    !loading && Object.keys(guideData).length === 0 &&
                    <h3 style={{color: 'darkred'}} className={styles.heading}>No User Guide Content Found</h3>
                }
                {
                    !loading && Object.keys(guideData).map(category => (
                        <div key={category} className={styles.categoryWrapper}>
                            <div className={styles.categoryHeader}>
                                <img onContextMenu={() => {
                                    return false;
                                }} style={{height: 30, width: 30}}
                                     className={`${styles.icon} noSelect`}
                                     src={`/assets/imgs/user_guide/${guideData[category]['icon']}.svg`} alt={"Chevron Arrow"}/>
                                {category}
                            </div>
                            <div className={styles.categoryContent}>
                                {
                                    guideData[category]['data'].map(contentItem => (
                                        <button key={contentItem[1]} onClick={()=>setSelectedHelpArticle(contentItem)} className={styles.categoryArticle}>
                                            {contentItem[1]}
                                        </button>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
            <PDFModal closeModal={resetModal} modalInformation={selectedHelpArticle} />
        </div>
    );
};

export default UserGuide;